var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"large"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('side-menu',{attrs:{"data":_vm.navigation}})],1),_c('el-col',{attrs:{"span":18}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }